module.exports = __webpack_public_path__ + "static/BT-mobile-5-31869032d74067794191198a059d18e6.jpg";